module.exports = __webpack_public_path__ + "media/images/rides/icon1-1aff5eb864c4f1dd61a10756bfaf6d54.svg";